// import { useEffect, useState, useCallback } from "react";
// import { Box, Typography, useMediaQuery } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { usePageLogger } from "../hooks/usePageLogger";
// import DropdownFormModal from "../components/ManageOptions/DropdownFormModal";
// import DropdownCard from "../components/ManageOptions/DropdownCard";
// import {
//   fetchDropdownOptions,
//   addDropdownOption,
//   updateDropdownOption,
//   deleteDropdownOption,
// } from "../redux/dropdownoptionsSlice";
// import { logger } from "../utils/logger";
// import SnackbarAlert from "../components/SnackBarAlert";

// const fieldTypes = [
//   "Salutation",
//   "PayMode",
//   "PayPurpose",
//   "Status",
//   "Utsavam",
//   "TamilMonths",
//   "Nachathiram",
//   "Thithi",
// ];

// const DropdownManager = () => {
//   const [tabIndex, setTabIndex] = useState(0);
//   const [openModal, setOpenModal] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [inputValue, setInputValue] = useState("");
//   const [tamilInputValue, setTamilInputValue] = useState("");
//   const { user } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const isMobile = useMediaQuery("(max-width: 600px)");
//   const currentField = fieldTypes[tabIndex];
//   const normalizedField = currentField.toLowerCase();
//   const { data, loading, error } = useSelector(
//     (state) => state.dropdownOptions
//   );
//   const options = data?.[normalizedField] || [];
//   const [feedback, setFeedback] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   // page logging
//   usePageLogger("Manage Options Page", {
//     username: user?.username,
//     role: user?.role,
//   });

//   // fetch dropdowns
//   useEffect(() => {
//     dispatch(fetchDropdownOptions(normalizedField))
//       .unwrap()
//       .then(() => {
//         logger.info("Dropdown options fetched successfully", {
//           field: currentField,
//           username: user?.username,
//           role: user?.role,
//         });
//       })
//       .catch((err) => {
//         logger.error("Error fetching dropdown options", {
//           field: currentField,
//           username: user?.username,
//           role: user?.role,
//           error: err?.message,
//         });
//       });
//   }, [dispatch, normalizedField, currentField, user]);

//   // add or edit option
//   const handleAddEdit = () => {
//     const action = editData
//       ? updateDropdownOption({
//           id: editData._id,
//           type: normalizedField,
//           value: inputValue,
//           tamilValue: tamilInputValue,
//         })
//       : addDropdownOption({
//           type: normalizedField,
//           value: inputValue,
//           tamilValue: tamilInputValue,
//         });

//     dispatch(action)
//       .unwrap()
//       .then(() => {
//         logger.info(
//           editData ? "Dropdown option updated" : "Dropdown option added",
//           {
//             field: currentField,
//             optionId: editData?._id,
//             value: inputValue,
//             username: user?.username,
//             role: user?.role,
//           }
//         );
//         setFeedback({
//           open: true,
//           message: editData
//             ? "Option updated successfully"
//             : "New option added successfully",
//           severity: "success",
//         });
//       })
//       .catch((err) => {
//         logger.error("Error saving dropdown option", {
//           field: currentField,
//           username: user?.username,
//           role: user?.role,
//           error: err?.message,
//         });
//         setFeedback({
//           open: true,
//           message: "Error saving dropdown option",
//           severity: "error",
//         });
//       });

//     setEditData(null);
//     setInputValue("");
//     setTamilInputValue("");
//     setOpenModal(false);
//   };

//   // delete option
//   const handleDelete = (index) => {
//     const option = options[index];
//     if (!option?._id) return;

//     dispatch(deleteDropdownOption({ id: option._id, type: normalizedField }))
//       .unwrap()
//       .then(() => {
//         logger.info("Dropdown option deleted", {
//           field: currentField,
//           optionId: option._id,
//           username: user?.username,
//           role: user?.role,
//         });
//         setFeedback({
//           open: true,
//           message: "Option deleted successfully",
//           severity: "success",
//         });
//       })
//       .catch((err) => {
//         logger.error("Error deleting dropdown option", {
//           field: currentField,
//           optionId: option._id,
//           username: user?.username,
//           role: user?.role,
//           error: err?.message,
//         });
//       });
//   };

//   // open edit modal
//   const openEditModal = (option) => {
//     setEditData(option);
//     setInputValue(option.value);
//     setTamilInputValue(option.tamilValue);
//     setOpenModal(true);
//   };

//   const handleCloseFeedback = useCallback(() => {
//     setFeedback({ ...feedback, open: false });
//   }, []);

//   return (
//     <Box
//       sx={{
//         p: { xs: 1, sm: 2, md: 3 },
//         width: "100%",
//         boxSizing: "border-box",
//         overflowX: "auto",
//       }}
//     >
//       <Typography variant={isMobile ? "h5" : "h4"} gutterBottom>
//         Manage Options
//       </Typography>

//       <DropdownCard
//         fieldTypes={fieldTypes}
//         tabIndex={tabIndex}
//         setTabIndex={setTabIndex}
//         currentField={currentField}
//         loading={loading}
//         error={error}
//         options={options}
//         onEdit={openEditModal}
//         onDelete={handleDelete}
//         onAddClick={() => {
//           setEditData(null);
//           setInputValue("");
//           setTamilInputValue("");
//           setOpenModal(true);
//         }}
//         username={user?.username}
//         role={user?.role}
//       />

//       <DropdownFormModal
//         open={openModal}
//         onClose={() => setOpenModal(false)}
//         onSave={handleAddEdit}
//         defaultValue={inputValue}
//         setValue={setInputValue}
//         defaultTamilValue={tamilInputValue}
//         setTamilValue={setTamilInputValue}
//         isEdit={!!editData}
//         label={currentField}
//         username={user?.username}
//         role={user?.role}
//       />

//       <SnackbarAlert feedback={feedback} onClose={handleCloseFeedback} />
//     </Box>
//   );
// };

// export default DropdownManager;
import { useEffect, useState, useCallback } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { usePageLogger } from "../hooks/usePageLogger";
import DropdownFormModal from "../components/ManageOptions/DropdownFormModal";
import DropdownCard from "../components/ManageOptions/DropdownCard";
import {
  fetchDropdownOptions,
  addDropdownOption,
  updateDropdownOption,
  deleteDropdownOption,
} from "../redux/dropdownoptionsSlice";
import { logger } from "../utils/logger";
import SnackbarAlert from "../components/SnackBarAlert";

const fieldTypes = [
  "Salutation",
  "PayMode",
  "PayPurpose",
  "Status",
  "Utsavam",
  "TamilMonths",
  "Nachathiram",
  "Thithi",
];

const DropdownManager = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [tamilInputValue, setTamilInputValue] = useState("");
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");

  // NEW: super admin gets an extra "Report Format" tab appended at the end
  const isSuperAdmin = user?.role === "superadmin";
  const allTabs = isSuperAdmin
    ? [...fieldTypes, "Report Format"]
    : fieldTypes;

  const isReportFormatTab = allTabs[tabIndex] === "Report Format";
  const currentField = isReportFormatTab ? "Report Format" : fieldTypes[tabIndex];
  const normalizedField = currentField.toLowerCase();
  const { data, loading, error } = useSelector(
    (state) => state.dropdownOptions
  );
  const options = data?.[normalizedField] || [];
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  usePageLogger("Manage Options Page", {
    username: user?.username,
    role: user?.role,
  });

  // fetch dropdowns — skip for the Report Format tab
  useEffect(() => {
    if (isReportFormatTab) return;
    dispatch(fetchDropdownOptions(normalizedField))
      .unwrap()
      .then(() => {
        logger.info("Dropdown options fetched successfully", {
          field: currentField,
          username: user?.username,
          role: user?.role,
        });
      })
      .catch((err) => {
        logger.error("Error fetching dropdown options", {
          field: currentField,
          username: user?.username,
          role: user?.role,
          error: err?.message,
        });
      });
  }, [dispatch, normalizedField, currentField, user, isReportFormatTab]);

  const handleAddEdit = () => {
    const action = editData
      ? updateDropdownOption({
          id: editData._id,
          type: normalizedField,
          value: inputValue,
          tamilValue: tamilInputValue,
        })
      : addDropdownOption({
          type: normalizedField,
          value: inputValue,
          tamilValue: tamilInputValue,
        });

    dispatch(action)
      .unwrap()
      .then(() => {
        logger.info(
          editData ? "Dropdown option updated" : "Dropdown option added",
          {
            field: currentField,
            optionId: editData?._id,
            value: inputValue,
            username: user?.username,
            role: user?.role,
          }
        );
        setFeedback({
          open: true,
          message: editData
            ? "Option updated successfully"
            : "New option added successfully",
          severity: "success",
        });
      })
      .catch((err) => {
        logger.error("Error saving dropdown option", {
          field: currentField,
          username: user?.username,
          role: user?.role,
          error: err?.message,
        });
        setFeedback({
          open: true,
          message: "Error saving dropdown option",
          severity: "error",
        });
      });

    setEditData(null);
    setInputValue("");
    setTamilInputValue("");
    setOpenModal(false);
  };

  const handleDelete = (index) => {
    const option = options[index];
    if (!option?._id) return;

    dispatch(deleteDropdownOption({ id: option._id, type: normalizedField }))
      .unwrap()
      .then(() => {
        logger.info("Dropdown option deleted", {
          field: currentField,
          optionId: option._id,
          username: user?.username,
          role: user?.role,
        });
        setFeedback({
          open: true,
          message: "Option deleted successfully",
          severity: "success",
        });
      })
      .catch((err) => {
        logger.error("Error deleting dropdown option", {
          field: currentField,
          optionId: option._id,
          username: user?.username,
          role: user?.role,
          error: err?.message,
        });
      });
  };

  const openEditModal = (option) => {
    setEditData(option);
    setInputValue(option.value);
    setTamilInputValue(option.tamilValue);
    setOpenModal(true);
  };

  const handleCloseFeedback = useCallback(() => {
    setFeedback({ ...feedback, open: false });
  }, []);

  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2, md: 3 },
        width: "100%",
        boxSizing: "border-box",
        overflowX: "auto",
      }}
    >
      <Typography variant={isMobile ? "h5" : "h4"} gutterBottom>
        Manage Options
      </Typography>

      <DropdownCard
        fieldTypes={allTabs}
        tabIndex={tabIndex}
        setTabIndex={setTabIndex}
        currentField={currentField}
        loading={isReportFormatTab ? false : loading}
        error={isReportFormatTab ? null : error}
        options={options}
        onEdit={openEditModal}
        onDelete={handleDelete}
        onAddClick={() => {
          setEditData(null);
          setInputValue("");
          setTamilInputValue("");
          setOpenModal(true);
        }}
        username={user?.username}
        role={user?.role}
        isReportFormatTab={isReportFormatTab} // NEW
      />

      {!isReportFormatTab && (
        <DropdownFormModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          onSave={handleAddEdit}
          defaultValue={inputValue}
          setValue={setInputValue}
          defaultTamilValue={tamilInputValue}
          setTamilValue={setTamilInputValue}
          isEdit={!!editData}
          label={currentField}
          username={user?.username}
          role={user?.role}
        />
      )}

      <SnackbarAlert feedback={feedback} onClose={handleCloseFeedback} />
    </Box>
  );
};

export default DropdownManager;